import { useCallback } from "react";
import { useResult } from "2g-grid";
import { useRedirect } from "b2b/hooks";

import { DATA } from "b2b/api/paths";
import { PATHS } from "b2b/constants";

import useMessages from "./i18n/useMessages";
import useColumns from "./useColumns";

export default function useZakazniciGrid() {
  const messages = useMessages();
  const columns = useColumns();
  const reditrect = useRedirect();
  const handleRowClick = useCallback(({ dataRow }) => {
    reditrect(PATHS.ADMINISTRACE.ZAKAZNIK, {
      ico: dataRow.ico
    });
  }, []);
  return useResult({
    title: messages.pageHeading(),
    url: DATA.zakaznici(),
    method: "get",
    columns,
    showFilterDescription: false,
    selectable: false,
    sortable: true,
    loadOnInit: true,
    onRowClick: handleRowClick
  });
}
